/* ui/tournament/StartButton.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	set_custom_element_data
} from "svelte/internal";

import { tournamentModeStore, game, scores } from "../store";
import { configuration, results, resultsStore } from "./tournament_store";

function create_fragment(ctx) {
	let sl_button;
	let mounted;
	let dispose;

	return {
		c() {
			sl_button = element("sl-button");

			sl_button.innerHTML = `<sl-icon slot="prefix" name="play"></sl-icon>
  Start
`;

			set_custom_element_data(sl_button, "type", "primary");
			set_custom_element_data(sl_button, "size", "small");
		},
		m(target, anchor) {
			insert(target, sl_button, anchor);

			if (!mounted) {
				dispose = listen(sl_button, "click", /*startTournament*/ ctx[0]);
				mounted = true;
			}
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(sl_button);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self) {
	function updateMatchResults() {
		let [oneMatches, twoMatches, ties] = results;

		if (scores[0] > scores[1]) {
			oneMatches++;
		} else if (scores[0] < scores[1]) {
			twoMatches++;
		} else {
			ties++;
		}

		resultsStore.update(() => [oneMatches, twoMatches, ties]);
	}

	function runMatch() {
		game.reset();
		let gameIsOver = false;

		while (!gameIsOver) {
			gameIsOver = game.gameLoop();
		}

		
		updateMatchResults();
	}

	function startTournament() {
		tournamentModeStore.update(() => true);
		let matches = 0;

		do {
			// setTimeout, even without a delay, allows other actions to
			// interleave with this loop. This allows the UI to update occasionally
			// without this the browser will ask to kill the script if we run long matches
			// I _think_ this is still in order, so matches run independently of each other
			setTimeout(runMatch);
		} while (++matches < configuration.tournament.matches);
	}

	return [startTournament];
}

class StartButton extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default StartButton;